import { all, fork } from 'redux-saga/effects';

import { tvPanelModuleSaga } from 'modules/tvpanel/moduleSaga';
import { commonModuleSaga } from 'modules/common/commonSaga';
import { securityModuleSaga } from 'modules/security/moduleSaga';
import { orderingModuleSaga } from 'modules/ordering/moduleSaga';
import { authModuleSaga } from 'modules/auth/moduleSaga';
import { adminModuleSaga } from 'modules/admin/moduleSaga';
import { directorModuleSaga } from 'modules/director/moduleSaga';
import { managerModuleSaga } from 'modules/manager/moduleSaga';

const sagas: Array<() => Generator> = [
  ...commonModuleSaga,
  ...securityModuleSaga,
  ...orderingModuleSaga,
  ...authModuleSaga,
  ...tvPanelModuleSaga,
  ...adminModuleSaga,
  ...directorModuleSaga,
  ...managerModuleSaga,
];

export default function* rootSaga() {
  const globalSagasForks = sagas.map((saga) => fork(saga));
  yield all([...globalSagasForks]);
}
